<template>
  <div v-observe-visibility="visibility" class="booking-frequency booking-step js-booking-step" v-show="this.$options._componentTag === this.getCurrentStep" :id="this.$options._componentTag">
    <h1 class="booking-title">{{ frequency.title ? frequency.title : 'Select the frequency of cleaning' }}</h1>
    <div class="booking-steps__wrap">
      <div class="booking-steps__wrap-upper">
        <span class="booking-label">Cleaning frequency</span>
        <span class="val-error js-cleaning-error">Please select a frequency</span>
        <div class="booking-steps__wrap-upper-btns">
          <div class="booking-steps__wrap-upper-btns-wrap js-freq-type js-freq-type-1" data-slug="one-time" @click="storeFrequency(1);selected = 1;frequencyType = 'one-time';changeActiveFrequency()" :class="{'is-active':selected === 1}">
            <a class="booking-steps__btn" href="javascript:;">One Time</a>
          </div>
          <div class="booking-steps__wrap-upper-btns-wrap js-freq-type js-freq-type-2" data-slug="one-recurring" @click="storeFrequency(2);selected = 2;frequencyType = 'recurring';changeActiveFrequency()" :class="{'is-active':selected === 2}">
            <a class="booking-steps__btn" href="javascript:;">Recurring</a>
            <span class="booking-steps__wrap-upper-btns-text">up to 10% off</span>
          </div>
        </div>
        <div class="booking-steps__wrap-bottom">
          <p class="booking-steps__wrap-bottom-text" v-if="policyText" v-html="policyText"></p>
        </div>
      </div>
      <div class="booking-side__image booking-location__image">
        <img class="media-item booking-side__image-firefox" :src="imagesPath" alt="animation">
        <div class="anim-holder">
          <div class="anim-container anim-container--04"></div>
        </div>
      </div>
    </div>
    <div class="booking-steps__wrap-bottom booking-steps__wrap-bottom--responsive">
      <p class="booking-steps__wrap-bottom-text" v-if="policyText" v-html="policyText"></p>
    </div>
  </div><!-- .booking-options -->
</template>


<script>

import {mapGetters} from 'vuex';
import Global from '../../../js/shared/global';
import lottieWeb from 'lottie-web';

export default {
  props: ['frequency', 'policyText'],
  data: function() {
    return {
      selected: null,
      imagesPath: process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/4.png',
      frequencyType: 'one-time',
      window: {
        width: 0
      }
    };
  },
  mounted() {
    this.animation();
  },
  methods: {
    animation() {
      setTimeout(() => {
        const animContainer = document.getElementsByClassName('anim-container--04');
        let animation;
        animContainer.forEach(function(el) {
          animation = process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/Icon4.json';
          const anim = lottieWeb.loadAnimation({
            container: el,
              animType: 'svg',
              loop: true,
              autoplay: true,
              path: animation,
              renderer: 'svg',
              rendererSettings: {
                progressiveLoad: true,
              },
          });
          anim.play();
        });
      }, 500);
    },
    visibility(isVisible) {
      if (isVisible) {
        this.preselectFrequency();
      }
    },
    changeActiveFrequency() {
      this.$store.dispatch('setActiveFrequency', this.frequencyType);
    },
    storeFrequency(val) {
      this.$store.dispatch('setTotal', {often: '', oldOften: ''});
      Global.setCookie('frequency', val);
      const error = document.querySelector('#BlockStepFrequency .js-cleaning-error');
      if (error) {
        error.style.display = 'none';
      }
    },
    preselectFrequency() {
      const frequency = Global.readCookie('frequency');
      const activeType = document.querySelector(`.js-freq-type.js-freq-type-${frequency}`);
      if (activeType) {
        activeType.click();
      }
      this.$store.dispatch('setActiveFrequency', this.frequencyType);
      this.selected = frequency;
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentStep',
    ])
  },
};
</script>

<style lang="scss" scoped>
.booking-frequency {

  .booking-label {
    font-size: 20px;
    letter-spacing: 4px;
    margin-bottom: 11px;

    @include mq($md) {
      font-size: 14px;
      text-align: center;
      margin: 0 auto 11px;
    }
  }

  .booking-steps__btn {
    min-width: 100%;
  }
}

.booking-steps__wrap-upper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 750px;
  width: 100%;

  @include mq($lap-mid) {
    max-width: 650px;
  }

  @include mq($xl) {
    max-width: 100%;
  }
}

.booking-steps__wrap-upper-btns {

  @include mq($xl) {
    margin: 0;
    justify-content: space-between;
  }
}

.booking-steps__wrap-upper-btns-wrap {
  width: 46%;
  margin-top: 20px;

  @include mq($lap-mid) {
    width: 44%;
  }

  @include mq($xl) {
    margin: 20px 0 0;
  }

  @include mq($md) {
    margin: 15px 0 0;
  }

  @include mq($xs-phone) {
    width: 100%;
  }
}

.booking-steps__wrap-bottom {
  width: 100%;
  margin-top: 80px;

  &.booking-steps__wrap-bottom--responsive {
    display: none;
    @include mq($xl) {
      display: block;
    }
  }

  @include mq($xl) {
    margin-top: 20px;
    max-width: 100%;
    display: none;
  }

  @include mq($lg) {
    margin-bottom: 20px;
  }
}

.booking-steps__wrap-bottom-text {
  font-size: 20px;
  font-family: $font-main;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.1px;
  line-height: 44px;
  color: $white;

  @include mq($lg) {
    font-size: 19px;
    line-height: 1.7;
  }

  @include mq($md) {
    font-size: 18px;
  }

  @include mq($phone) {
    font-size: 15px;
  }

  br {

    @include mq($xl) {
      display: none;
    }
  }
}

.booking-side__image {

  @include mq($xl) {
    max-width: 40%;
    margin-bottom: 30px;
    margin-top: 30px;

    img {
      margin: 0 auto;
    }
  }

  @include mq($lg) {
    max-width: 300px;
    margin-bottom: 0;
  }
}
</style>
